
<div class="template-config wm-tile-container"
    [ngClass]="{'ng-hide': (widgetType === 'wm-table' || activeLiveWidget === 'wm-list' || activeLiveWidget === 'wm-card') && activeInnerStep !== 'layout', 'col-xs-8': activeLiveWidget === 'wm-liveform' || (!isNativeMobileApplicationType && activeLiveWidget === 'wm-form') || activeLiveWidget === 'wm-livefilter', 'col-xs-12': (isNativeMobileApplicationType && activeLiveWidget === 'wm-form') || widgetType !== 'wm-liveform'}">

    <tabset class="wm-tabs layout-tabs" *ngIf="widgetType === 'wm-table' && activeLiveWidget === 'wm-table'">
            <!-- active]="iconFamily.render" (selectTab)="renderIconFamily($index);"-->
            <tab *ngFor="let group of fileOptionsList" [disabled]="!(widgetType === 'wm-table' && activeLiveWidget === 'wm-table' && !steps[0].dynamicWidget && ((variableFilter?.category === 'wm.LiveVariable') || (variableFilter?.category === 'wm.CrudVariable' && gridOptions.canEdit) || variableFilter?.category === 'wm.Variable' || widgetConfig.bindMode === 'widget'))"
                [active]="group.active" (selectTab)="onEditToggle(group.value)">
                <ng-template tabHeading class="tab-heading">
                    <span class="wm-workspace-tab-head-text">{{group.name}}</span>
                </ng-template>
            </tab>
        </tabset>
      <ul class="list-inline padded-container wm-tile-list select-template-list"
        [ngClass]="{'list-templates': activeLiveWidget === 'wm-list' || activeLiveWidget === 'wm-card', 'prism-web-card-temp': isPrismWeb && activeLiveWidget === 'wm-card', 'prism-web-list-temp': isPrismWeb && activeLiveWidget === 'wm-list' , 'native-mobile-card-temp': isNativeMobileApplicationType && activeLiveWidget === 'wm-card', 'native-mobile-list-temp': isNativeMobileApplicationType && activeLiveWidget === 'wm-list'}">
        <ng-container
            *ngIf="!(isNativeMobileApplicationType && (activeLiveWidget === 'wm-list' || activeLiveWidget === 'wm-card'))">
            <li class="tile"
                [style]="{width: isNativeMobileApplicationType && (activeLiveWidget === 'wm-list' || activeLiveWidget === 'wm-card') ? '25%' : '25%'}"
                id="wms-tpl-{{template?.id}}"
                *ngFor="let template of (isPrismWeb ? liveWidgetLayouts : (liveWidgetLayouts | orderBy: 'title')) | filter: 'isEditable': widgetType === 'wm-table' && activeLiveWidget === 'wm-table' ? gridOptions.isEditable : null"
                (click)="onWidgetSelect(template)" [ngClass]="{'active': template?.id === selectedLiveWidgetLayout?.id}"
                title="{{locale[template?.labelKey] || template?.title}}">
                <div class="wm-tile-thumbnail-ctr">
                    <i class="wm-tile-thumbnail wms-icon wms-widget-template {{ isPrismWeb ? (template.id + '-web web-thumbnails') : template.id }}"></i>
                </div>
                <p class="wm-tile-name">{{locale[template.labelKey] || template.title}}</p>
            </li>
        </ng-container>
        <ng-container
            *ngIf="(isNativeMobileApplicationType && (activeLiveWidget === 'wm-list' || activeLiveWidget === 'wm-card'))">
            <li class="tile"
                [style]="{width: isNativeMobileApplicationType && (activeLiveWidget === 'wm-list' || activeLiveWidget === 'wm-card') ? '25%' : '25%'}"
                id="wms-tpl-{{template.id}}"
                *ngFor="let template of liveWidgetLayouts | filter: 'isEditable': gridOptions.isEditable !== undefined ? gridOptions.isEditable : null"
                (click)="onWidgetSelect(template)" [ngClass]="{'active': template.id === selectedLiveWidgetLayout?.id}"
                title="{{locale[template.labelKey] || template.title}}">
                <div class="wm-tile-thumbnail-ctr">
                    <i class="wm-tile-thumbnail wms-icon wms-widget-template {{template?.id}}"></i>
                </div>
                <p class="wm-tile-name">{{locale[template.labelKey] || template.title}}</p>
            </li>
        </ng-container>
    </ul>
</div>
<div class="col-xs-12 navigation-config wm-tile-container" [ngClass]="{'active': activeInnerStep === 'pagination'}"
    *ngIf="activeLiveWidget === 'wm-table' || activeLiveWidget === 'wm-list' || activeLiveWidget === 'wm-card'">
    <ul class="list-inline padded-container wm-tile-list select-template-list list-templates">
        <li class="tile" id="wms-nav-{{navType?.id}}" *ngFor="let navType of navigationList"
            title="{{locale['MESSAGE_NAVIGATION_HELP_TEXT_' + navType.id.toUpperCase()]}}"
            (click)="onNavigationSelect(navType)"
            [ngClass]="{'active': liveWidgetNavigation?.selectedNavigation === navType}">
            <div class="wm-tile-thumbnail-ctr wm-pagination-icon {{navType?.id?.toLowerCase()}}"
                [ngClass]="{'table-scroll': navType?.id?.toLowerCase() === 'scroll' && activeLiveWidget === 'wm-table'}">
                <i class="wm-tile-thumbnail"></i>
            </div>
            <p class="wm-tile-name">{{(locale["LABEL_PAGINATION_"+ navType?.label?.toUpperCase()] || navType?.label)}}
            </p>
        </li>
    </ul>
</div>
<div class="col-xs-4 widget-options"
    *ngIf="!isNativeMobileApplicationType && (activeLiveWidget === 'wm-liveform' || activeLiveWidget === 'wm-livefilter' || activeLiveWidget === 'wm-form')">
    <div class="clearfix" *ngIf="activeLiveWidget === 'wm-liveform' && widgetType === 'wm-liveform'">
        <label class="col-xs-3 app-label">{{locale.LABEL_PROPERTY_MODE}}</label>
        <div class="col-xs-9 app-control">
            <wms-toggle [id]="'formMode'" [customClasses]="'switch'" onValue="EDITABLE" offValue="READONLY" [onLabel]="locale.LABEL_EDITABLE"
                [offLabel]="locale.LABEL_READONLY" [model]="widgetConfig?.widgetMode?.toUpperCase()" (onChange)="updateWidgetMode($event)"></wms-toggle>
        </div>
    </div>
    <div class="clearfix"
        *ngIf="!isMobileApplicationType && ((activeLiveWidget === 'wm-form' && widgetType !== 'wm-table') || (activeLiveWidget === 'wm-liveform' && widgetType === 'wm-liveform'))">
        <label class="col-xs-3 app-label">{{locale.LABEL_TYPE}}</label>
        <div class="col-xs-9 app-control">
            <wms-toggle [id]="'formType'" name="wms-widget-dialog-mode" [customClasses]="'switch'" onValue="INLINE" offValue="DIALOG"
                [onLabel]="locale.LABEL_INLINE" [offLabel]="locale.LABEL_DIALOG"
                [model]="widgetConfig?.formType?.toUpperCase()" (onChange)="updateWidgetFormType.emit($event)"></wms-toggle>
        </div>
    </div>
    <h4 class="property-subgroup-name">{{locale.LABEL_PROPERTY_CAPTION}}</h4>
    <label class="col-xs-3 app-label">{{locale.LABEL_PROPERTY_ALIGN}}</label>
    <div class="col-xs-9 app-control">
        <div class="toggle-property property-wrapper">
            <span *ngFor="let align of captionAlignments">
                <label class="radiotemplate-label caption wms wms-align-{{align}}"
                    [ngClass]="{'active': currentStep.captionAlign === align }" (click)="setCaptionAlign.emit(align)"
                    title="{{locale['LABEL_' + align?.toUpperCase()]}}"></label>
            </span>
        </div>
    </div>
    <label class="col-xs-3 app-label">{{locale.LABEL_PROPERTY_CAPTIONPOSITION}}</label>
    <div class="col-xs-9 app-control">
        <div class="toggle-property">
            <div *ngFor="let position of captionPositions" class="property-lg">
                <input id="radioposition{{position}}" type="radio" name="captionPosition"
                    [ngModel]="currentStep?.captionPosition" value="{{position}}" />
                <label for="radioposition{{position}}"
                    class="radiotemplate-label fa-3x caption wms wms-caption-position-{{position}}"
                    (click)="setCaptionPosition.emit(position)"
                    title="{{locale['LABEL_' + position?.toUpperCase()] || position}}"></label>
            </div>
        </div>
    </div>
</div>
<div class="wms-wizard-body-content"></div>
